const data = {
    data () {
        return {
            data_status: 'init',
            cols: {}, // исходные данные по столбцам
            data: [], // это исходные данные
            parameters: {},
            sort: {
                active: 'id',
                direction: 'DESC'
            },
            paginator: {
                per_page: 25,
                current: 1,
                max: null
            },
            data_count: 0,
            data_show_from: 1,
            data_show_to: 1
        }
    },
    created () {
        this.getData().then(() => {
            //this.createFilters()
            //this.createSettings()
        })
    },
    computed: {
        renderCols () {
            let result = {}
            for (let key in this.cols) {
                if (this.$store.state.settings[this.$route.name][key] && this.$store.state.settings[this.$route.name][key].value) {
                    result[key] = this.cols[key]
                }
            }
            return result
        },
        renderData () {
            let result = this.data
            let filters = this.$store.state.filters[this.$route.name]


            if (localStorage['sorting']) {
                let sort = JSON.parse(localStorage['sorting'])
                if (sort[this.$route.name]) {
                    this.updateSort(sort[this.$route.name])
                }
            }


            for (let key in filters) { // перебираем фильтры столбцов
                if (!this.$store.state.settings[this.$route.name][key].value) continue
                if (!filters[key].all) { // если в фильтре отключены некоторые элементы
                    for (let uniqValue in filters[key]) { // перебираем ключи этого фильтра
                        if (!filters[key][uniqValue]) { // если значение исключено
                            result = result.filter(dataItem => {
                                if (!dataItem[key] || dataItem[key] == '') return false
                                if (dataItem[key] && dataItem[key].id) {
                                    return dataItem[key].value != uniqValue
                                } else if (Array.isArray(dataItem[key])) {
                                        for (let arrayItem of dataItem[key]) {
                                            if (arrayItem.value == uniqValue) return false
                                        }
                                        return true
                                } else {
                                    return dataItem[key] != uniqValue
                                }
                            })
                        }
                    }
                }
            }

            this.data_count = result.length

            result = this.doSort(result)

            result = this.setPaginator(result)

            return result
        }
    },
    methods: {
        updateDate (e) {
            if (e.type == 'from') {
                this.parameters.date_from = e.date
            } else if (e.type == 'to') {
                this.parameters.date_to = e.date
            }
            this.getData()
        },
        setPaginator (array) {
            this.paginator.max = Math.ceil(array.length / this.paginator.per_page)
            if (this.paginator.current > this.paginator.max) this.paginator.current = 1

            this.data_show_from = (this.paginator.current - 1) * this.paginator.per_page
            this.data_show_to = this.data_show_from + this.paginator.per_page
            if (this.data_show_to > array.length) this.data_show_to = array.length

            let result = array.slice(this.data_show_from, this.data_show_to)

            return result
        },
        doSort (array) {
            let isFloat, isDate = false
            if (this.sort.active == 'lat' || this.sort.active == 'lng') {
                isFloat = true
            }
            if (this.sort.active == 'ctime' || this.sort.active == 'utime') {
                isDate = true
            }
            array.sort((a, b) => {
                let value1 = a[this.sort.active],
                    value2 = b[this.sort.active]

                if (typeof value1 == 'object') {
                    if (!value1) return 1
                    value1 = value1.value
                } else if (value1 === '') return 1

                if (typeof value2 == 'object') {
                    if (!value2) return -1
                    value2 = value2.value
                } else if (value2 === '') return -1

                if (isDate) {
                    value1 = new Date(value1)
                    value2 = new Date(value2)
                } else if (isFloat) {
                    value1 = parseFloat(value1)
                    value2 = parseFloat(value2)
                }
                if (this.sort.direction == 'ASC') {
                    if (value1 > value2) return 1
                    if (value1 < value2) return -1
                } else {
                    if (value1 > value2) return -1
                    if (value1 < value2) return 1
                }
                return 0;
            })
            return array
        },
        createSettings () {
            let data = {
                page: this.$route.name,
                cols: this.cols
            }
            this.$store.commit('settings/set_cols', data)
        },
        getUniqueInArray (array) {
            return array.reduce((unique, item) => {
                let current = (item && typeof item.id != 'undefined') ? item.value : item
                if (unique.includes(current)) {
                    return unique
                } else {
                    return [...unique, current]
                }
            }, [])
        },
        getColumnData (col_id) {
            let result = []
            for (let item of this.data) {
                for (let key in item) {
                    if (key != col_id) continue
                    if (item[key] !== '' && item[key] !== null) {
                        if (Array.isArray(item[key])) {
                            for (let parking of item[key]) {
                                result.push(parking.value)
                            }
                        } else {
                            result.push(item[key])
                        }
                    }
                }
            }
            return result
        },
        updateSort (sort) {
            this.sort.active = sort.active
            this.sort.direction = sort.direction
        },
        setSort (key) {
            if (this.sort.active == key) {
                if (this.sort.direction == 'DESC') this.sort.direction = 'ASC'
                else if (this.sort.direction == 'ASC') this.sort.direction = 'DESC'
            } else {
                this.sort.active = key
                this.sort.direction = 'DESC'
            }

            let saved_sorting = localStorage['sorting'] ? JSON.parse(localStorage['sorting']) : {}
            saved_sorting[this.$route.name] = this.sort
            localStorage['sorting'] = JSON.stringify(saved_sorting)
        },
        createFilters () {
            let data = []
            for (let col in this.cols) {
                let filter = {all: true}
                let colData = this.getColumnData(col)
                let unique = this.getUniqueInArray(colData)

                for (let item of unique) filter[item] = true

                data.push({
                    name: col,
                    value: filter
                })
            }
            this.$store.commit('filters/set_filter', {
                page: this.$route.name,
                fields: data
            })
        },
        getData () {
            return new Promise((resolve, reject) => {
                this.data_status = 'loading'

                let methodName = this.$route.name
                let params = ''
                if (this.parameters.date_from || this.parameters.date_to) {
                    let from = this.parameters.date_from ? this.parameters.date_from : ''
                    let to = this.parameters.date_to ? this.parameters.date_to : ''
                    params = '?date_from=' + from + '&date_to=' + to
                }

                this.axios.get('api/admin/v2/' + methodName + params)
                    .then(resp => {
                        this.cols = resp.data.response.fields
                        this.data = resp.data.response.data
                        this.parameters = resp.data.response.parameters
                        this.data_status = ''
                        this.createFilters()
                        this.createSettings()
                        resolve()
                    })
                    .catch(() => {
                        this.data_status = ''
                        reject()
                    })
            })
        }
    }
}

export default data